import { Button, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

const NotAuthorizedPage = () => {
  return (
    <Grid container spacing={3} justify="center">
      <Grid item xs={8} className="text-center">
        <Typography variant="h2" component="h2" className="mt-10">
          401: Authorization required
        </Typography>
        <Typography className="text--muted">
          You either tried some shady route or you came here by mistake.
          Whichever it is, try using the navigation.
        </Typography>
        <img
          src="/assets/images/error.svg"
          alt="401 not authorized"
          className="mt-5"
        />
        <div className="mt-5">
          <Button component={Link} to="/app" variant="outlined">
            Dashboard
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default NotAuthorizedPage;
